import React from 'react';
import {FormInputComponent} from "../../../components/form/Form";
import {useOutletContext, useParams} from "react-router-dom";
import {usePositionForm} from "../../../providers/PositionFormProvider";
import {Input} from "formsy-react-components";

const PositionTitle = props => {

    const {'*': step} = useParams();

    const {
        isDisabled, goBack, onSubmit, onChange, onSkip, isReadOnly,
        positionIndex
    } = useOutletContext();
    const {formModel: position, isProjectUpdating} = usePositionForm();


    return (
        <div className="flex flex-col justify-start items-stretch self-stretch relative gap-4" id="title-section-start">
            {TB.isDefined(positionIndex) && (
                <p className="byo-position-nav-label">
                    {/* Role <b className="current-position">#{positionIndex}</b> */}
                     Position <b className="current-position">#{positionIndex}</b>
                </p>
            )}
            {!props.hideLabel && (
                <h5 className="mb-0">
                    What do you want to name this open position?
                </h5>
            )}
            <FormInputComponent
                fieldName="title"
                type="antd-input"
                label={false}
                required={true}
                disabled={isDisabled || isProjectUpdating}
                value={position.title}
                isReadOnly={isReadOnly}
            >

                <Input
                    type="text"
                    label={false}
                    name="title"
                    // placeholder="Name of role"
                    placeholder="Open position name"
                    autoComplete="off"
                    value={position.title}
                    disabled={isDisabled || isProjectUpdating}
                    maxLength={85}
                    required={true}
                    tabIndex={isReadOnly ? -1 : undefined}
                    id="title-input"
                    validationErrors={{
                        isDefaultRequiredValue:"Position name is required."
                    }}
                />
            </FormInputComponent>

        </div>
    );
};

PositionTitle.propTypes = {};

export default PositionTitle;